import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { VersionService } from '../../core/services/version.service';

export const appVersionResolver: ResolveFn<boolean> = () => {
  inject(VersionService).checkVersionAndClean();
  return true;
};
